import { AutoComplete, Icons, Input } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { useEffect, useState } from 'react'

import { supabaseClient } from 'utility'

const { SearchOutlined } = Icons

type UsersFinderProps = {
  updateUserData: Function
}

export const UsersFinder: React.FC<UsersFinderProps> = ({ updateUserData }) => {
  const t = useTranslate()

  const [value, setValue] = useState<string>('')
  const [options, setOptions] = useState<any[]>([])

  const updateSelected = (item: any) => {
    updateUserData(item)
  }

  const renderItem = (label: string, item: any) => {
    return (
      <div onClick={(e) => {
        e.preventDefault()
        updateSelected(item)
      }}>
        <p style={{ height: '15px', textAlign: 'start' }}>{label}</p>
      </div>
    )
  }

  const refetchPosts = async () => {
    const { data: users, error: errorUsers } = await supabaseClient
      .from('users')
      .select('id, email, name, default_billing_address_id(id, nif), default_shipping_address_id(id, nif)')
      .or(`email.ilike.%${value}%, name.ilike.%${value}%`)
      .eq('deleted', false)

    if (errorUsers) {
      return
    }

    if (users) {
      const data = [...users]
      data.forEach(item => {
        item.label = renderItem(`${item.name} ----- ${item.email}`, item)
      })

      if (data.length > 0) {
        setOptions([
          {
            label: (<p>{'Users'}</p>),
            options: data
          }
        ])
      }
    }
  }

  useEffect(() => {
    setOptions([])
    refetchPosts()
  }, [value])

  return (
    <>
      <AutoComplete
        style={{ width: '100%', marginBottom: '1rem' }}
        filterOption={false}
        options={options}
        onSearch={(value: string) => setValue(value)}
      >
        <Input
          size="large"
          placeholder={t('codes.fields.searchUsersText')}
          suffix={<SearchOutlined />}
        />
      </AutoComplete>
    </>
  )
}
